'use strict';

/* Services */

angular.module('game').value('version', '0.1')
  .factory('audioService', ['$q', 'contentURL', 'mediaURL', '$timeout', 'gameSettings', 'playerService',
    function ($q, contentURL, mediaURL, $timeout, gameSettings, playerService) {

      var audioPlayer = undefined;

      function getAudioPlayer(create) {
        if (create === undefined) {
          create = true;
        }

        var audioTrack = 'audioTrack';
        var $audioTrack = angular.element('#' + audioTrack);

        if (create && $audioTrack.length === 0) {
          $audioTrack = $('<audio id="' + audioTrack + '">');
          $('<div class="audiotrack-wrapper">')
            .append($audioTrack).appendTo('body');
        }
        if (create && audioPlayer === undefined) {
          audioPlayer = playerService.create(audioTrack);
        }

        return audioPlayer;
      }

      return {
        song: {
          url: undefined,
          bucle: undefined,
          type: undefined
        },
        repeat: false,
        setVolume: function (volume) {
          getAudioPlayer().setVolume(volume);
        },
        getVolume: function () {
          return getAudioPlayer().getVolume();
        },
        play: function () {
          var audioPlayer = getAudioPlayer();

          if (!audioPlayer.isPlaying() && this.song.url) {
            var setup = {
              'file': this.song.url.startsWith('http') ? this.song.url : mediaURL + this.song.url,
              'loop': this.repeat
            };
            audioPlayer.setup(setup);
            audioPlayer.play();
          }

        },
        stop: function () {
          var audioPlayer = getAudioPlayer();
          audioPlayer.stop();
        },
        audioPlayer: function () {
          return getAudioPlayer();
        }
      }
    }
  ]);